import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Logo from '../../components/Svg/ActionButtonLogo';
import PublisherLogo from '../../components/Widget/PublisherLogo';
import PartnerLogo from '../../components/Widget/PartnerLogo';
import { SponsoredTag } from '../../components/Widget/SponsoredTag';

import { copyFor } from '../../copy/copy';

import {
    setOverlayVisible,
    setOverlayPublisherVisible,
    setOverlayPartnerVisible
} from './actions';

import getIsLegacyDonation from '../../utils/donation/isLegacyDonation';

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 24px;
    max-height: 30px;
`;

const LogoWrapper = styled.div`
    &.hide {
        display: none;
    }
`;

const WidgetHeader = props => (
    <Header>
        <Logo
            showPoweredBy={props.showPoweredBy}
            onClick={() => props.setOverlayVisible(true)}
            hideActionButtonText={
                props.isSponsored || props.createdByThirdParty ||
                props.isLegacyDonation
            }
        />
        <LogoWrapper>
            {props.partnerLogo && props.isPartnerLogoVisible && (
                <PartnerLogo
                    logoUrl={props.partnerLogo}
                    onClick={() => props.setOverlayPartnerVisible(true)}
                />
            )}
            {(props.isSponsored || props.createdByThirdParty) && (
                <SponsoredTag
                    isVisual={props.isVisual}
                    sponsoredText={props.sponsoredText}
                />
            )}
            {props.publisherLogoUrl && !props.isPartnerLogoVisible && (
                <PublisherLogo
                    logoUrl={props.publisherLogoUrl}
                    onClick={() => props.setOverlayPublisherVisible(true)}
                />
            )}
        </LogoWrapper>
    </Header>
);

WidgetHeader.propTypes = {
    createdByThirdParty: PropTypes.bool.isRequired,
    isPartnerLogoVisible: PropTypes.bool.isRequired,
    isSponsored: PropTypes.bool,
    isVisual: PropTypes.bool,
    partnerLogo: PropTypes.string,
    publisherLogoUrl: PropTypes.string,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    setOverlayPublisherVisible: PropTypes.func.isRequired,
    setOverlayVisible: PropTypes.func.isRequired,
    showPoweredBy: PropTypes.bool,
    sponsoredText: PropTypes.string
};

export default connect(
    (state, props) => {
        const currentCard = state.widget.cards.find(
            c => c.id === state.widget.activeAction.widgetCardId
        );

        return {
            createdByThirdParty: state.widget.createdByThirdParty,
            isLegacyDonation: getIsLegacyDonation(state),
            isPartnerLogoVisible: currentCard.logoSource === 1,
            isSponsored: state.widget.isSponsored,
            isVisual: state.widget.activeAction.isVisual,
            partnerLogo: (state.widget.selectedPartner || {}).logoUrl || '',
            publisherLogoUrl: state.widget.publisherLogoUrl,
            showPoweredBy: state.widget.publisherId === 54, // MSN ID
            sponsoredText:
                state.widget.sponsoredText || copyFor('miscellaneous', 'sponsored'),
        };
    },
    { setOverlayVisible, setOverlayPublisherVisible, setOverlayPartnerVisible }
)(WidgetHeader);
